const constants = {
  AUTH_TOKEN_LIFE_SPAN: '2592000',
  TOKEN: 'token',
  BANNER_HEADER: "Groceries Delivered in 90 Minutes",
  AR_BANNER_HEADER: "يتم تسليم البقالة في 90 دقيقة",
  BANNER_SUB_HEADER: "Get your healthy foods & snacks delivered at your doorsteps all day, every day.",
  AR_BANNER_SUB_HEADER: "احصل على الأطعمة الصحية والوجبات الخفيفة التي يتم توصيلها إلى باب منزلك طوال اليوم وكل يوم.",
  ORDER_PLACE_CHANNEL: 'place-order-channel',
  order: 'order',
  PROCESSING: 'processing',
  LOCAL_FACLITY: 'local-facility',
  OUT_FOR_DELIVERY: 'out-for-delivery',
  DELIVERED: 'delivered',
};

export default constants;
